import { storyblokEditable } from '@storyblok/react'

import { IFrameEmbed as VideoEmbedComponents } from '../../../embed/components/iframe-embed'
import { setLazyLoadingOnIframe } from '../../../embed/utils'

interface VideoEmbedProps {
  blok: {
    _uid: string
    iframe_code: string
  }
}

export const VideoEmbed = ({ blok }: VideoEmbedProps) => {
  return (
    <div {...storyblokEditable(blok)}>
      <VideoEmbedComponents
        iFrameCode={setLazyLoadingOnIframe(blok.iframe_code)}
        isVideo={true}
      />
    </div>
  )
}
